import { render, staticRenderFns } from "./RelatorioDRECard.vue?vue&type=template&id=0f05e8fc"
import script from "./RelatorioDRECard.vue?vue&type=script&lang=js"
export * from "./RelatorioDRECard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports